import { render, staticRenderFns } from "./BaseBlockHelpDocument.vue?vue&type=template&id=e47bf4b4&scoped=true&"
import script from "./BaseBlockHelpDocument.vue?vue&type=script&lang=js&"
export * from "./BaseBlockHelpDocument.vue?vue&type=script&lang=js&"
import style0 from "./BaseBlockHelpDocument.vue?vue&type=style&index=0&id=e47bf4b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47bf4b4",
  null
  
)

export default component.exports